import React, { memo } from 'react';
import BLandingCss from './BLandingPage.css';
import { TrustBox } from '../../components';
import vulcanPost from '../../assets/hostLanding/vulcan.png';
import theStraitsTime from '../../assets/hostLanding/straits.png';
import cna from '../../assets/hostLanding/cna.png';
import zaobao from '../../assets/hostLanding/zao.png';
import insuranceLogo from '../../assets/insurance-logo.svg';
import classNames from 'classnames';

export const Channels = () => (
  <div className={BLandingCss.channelOuter}>
    <div className={BLandingCss.channelsGridRow}>
      <a
        href="https://www.straitstimes.com/singapore/transport/car-not-used-much-rent-it-out-for-cash"
        className={BLandingCss.channelItem}
        target="_blank"
      >
        <img
          className={BLandingCss.channelItemImage}
          src={theStraitsTime}
          alt="THE STRAITS TIMES"
        />
      </a>
      <a
        href="https://www.facebook.com/drivelah2018/videos/drive-lah-featured-on-channel-news-asia/991990264536564/"
        target="_blank"
        className={BLandingCss.channelItem}
      >
        <img className={BLandingCss.channelItemImage} src={cna} alt="CNA" />
      </a>
      <a
        href="https://vulcanpost.com/679151/p2p-car-sharing-drive-lah-singapore/"
        target="_blank"
        className={BLandingCss.channelItem}
      >
        <img className={BLandingCss.channelItemImage} src={vulcanPost} alt="Vulcan Post" />
      </a>
      <a
        href="https://www.zaobao.com.sg/news/singapore/story20191116-1005643"
        className={BLandingCss.channelItem}
        target="_blank"
      >
        <img className={BLandingCss.channelItemImage} src={zaobao} alt="ZAOBAO" />
      </a>
    </div>
  </div>
);

const ChannelsListings = memo(({ isMobileLayout, openInsuranceModal }) => {
  return (
    <>
      {isMobileLayout && (
        <div className={BLandingCss.insuranceListingWrapper}>
          <div
            className={BLandingCss.trustPilotLogoMobile}
            style={{ flex: '0 0 45%', maxWidth: '45%' }}
          >
            <TrustBox />
          </div>
          {/* <div style={{ flex: '0 0 40%', maxWidth: '40%', padding: '0 0 0 15px' }}>
            <div style={{ marginBottom: 10 }}>
              <div className={BLandingCss.insuranceListingText}>Insurance provided by</div>
              <img
                className={BLandingCss.insuranceListingImage}
                src={insurance}
                alt="Tokio Marine"
              />
            </div>
            <div>
              <div className={BLandingCss.insuranceListingText}>Approved by</div>
              <img
                className={BLandingCss.approvedByCompanyLogo}
                src={landTransport}
                alt="Land Transport"
              />
            </div>
          </div> */}
          <div style={{ flex: '0 0 55%', maxWidth: '55%' }} className={classNames(BLandingCss.comprehensiveInsuranceBlock, BLandingCss.channelListingBlock)} onClick={openInsuranceModal}>
            <div className={BLandingCss.comprehensiveInsuranceBlockWrapper}>
              <div className={BLandingCss.cILogo}>
                <img src={insuranceLogo} alt="Drive lah Protection" />
              </div>
              <div className={BLandingCss.cIContent}>
                <span className={BLandingCss.channelListingSpan}>
                Comprehensively insured with Drive lah protection<sup>TM</sup>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={BLandingCss.channelsListings}>
        <Channels />
      </div>
    </>
  );
});

export default ChannelsListings;
